import React from "react";
import { ImageBackground } from "react-native";

import { VStack } from "@whoosh/design-system/src/components/primitive";
import { useBreakpointValue } from "@whoosh/design-system/src/hooks/useBreakpointValue";
import { images } from "@whoosh/design-system/src/theme/images";

import { useCheckForUpdates } from "../../utils/expoUpdates/useCheckForUpdates";
import { ErrorDisplayingFallback } from "./components/ErrorDisplayingFallback/ErrorDisplayingFallback";

type SentryErrorContentProps = {
  resetError: () => void;
  eventId: string;
};

export const SentryErrorContent = ({
  resetError,
  eventId,
}: SentryErrorContentProps) => {
  const isMobileLayout = useBreakpointValue({
    base: true,
    xs: true,
    sm: true,
    md: false,
  });

  /**
   * IF we render our error page - see if we have any app updates
   */
  useCheckForUpdates();

  return (
    <ImageBackground
      source={
        isMobileLayout
          ? images.initialBackground
          : images.desktopLandingBackground
      }
      resizeMode="cover"
      style={{ flex: 1 }}
    >
      <VStack justifyContent="center" alignItems="center" height="100%">
        <ErrorDisplayingFallback eventId={eventId} resetError={resetError} />
      </VStack>
    </ImageBackground>
  );
};
